// Shared helpers used across every hero-artwork module.
// Anything that lives here is intentionally tiny so the per-art bundles
// can be code-split without dragging unused icon imports along with them.

import React from "react";

/* glassCard · base style for floating glassmorphic surfaces.
   Shadow is intentionally muted (was 30% accent / 60px blur which caused
   visible coloured bleed below/right of multi-tile grids like MarketsArt).
   The dark portion of the shadow stays for depth; the accent tint is
   dialled back so adjacent tiles' coloured glows don't stack visibly. */
export const glassCard = (accent, opacity = 90) => ({
  background: `linear-gradient(160deg,
    color-mix(in srgb, var(--surface-2) ${opacity}%, transparent) 0%,
    color-mix(in srgb, var(--surface) ${opacity}%, transparent) 100%)`,
  border: `1px solid color-mix(in srgb, ${accent} 26%, transparent)`,
  backdropFilter: "blur(14px)",
  WebkitBackdropFilter: "blur(14px)",
  boxShadow: `0 16px 32px -18px color-mix(in srgb, ${accent} 12%, rgba(0,0,0,0.55)),
              0 8px 18px -8px rgba(0,0,0,0.38),
              inset 0 1px 0 rgba(255,255,255,0.05)`,
});

/* Gold accent · BonusArt member card palette */
export const GOLD = "#d4af37";

/* Mini sparkline · helper used across slides */
export function Sparkline({ data, color, w = 60, h = 20 }) {
  // Guard · skip when data is missing or too short. Otherwise
  // `Math.min(...[])` returns Infinity, every computed coord becomes
  // NaN, and React's SVG layer emits "cx: undefined" warnings.
  if (!Array.isArray(data) || data.length < 2) return null;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min || 1;
  const pts = data.map((v, i) => {
    const x = (i / (data.length - 1)) * w;
    const y = h - ((v - min) / range) * (h - 2) - 1;
    return `${x},${y}`;
  }).join(" ");
  return (
    <svg viewBox={`0 0 ${w} ${h}`} className="overflow-visible" style={{ width: w, height: h }}>
      <polyline points={pts} fill="none" stroke={color} strokeWidth="1.4" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  );
}
